<template>
    <div>
        <DialogoConfirmar ref="dialogoConfirmar" :msgAceptar="aceptar" :msgCancelar="cancelar" :msg="mensaje" />
        <v-dialog v-model="isActive" :width="width" transition="dialog-bottom-transition" persistent
            :fullscreen="$vuetify.breakpoint.xsOnly" @click.outside="confirmAndClose(false)">
            <v-card flat class="rounded-0">
                <v-card flat class="rounded-0">
                    <v-app-bar color="white">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon @click.outside="confirmAndClose(false)"
                                    @keydown.esc="confirmAndClose(false)">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar</span>
                        </v-tooltip>
                        <v-toolbar-title>
                            <div class="text-h6 font-weight-bold primary--text">
                                {{ titulo }}
                            </div>
                        </v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card flat class="rounded-0">
                    <v-card-text class="ma-0 pa-0">
                        <v-row class="ma-0 pa-0">
                            <v-col cols="12" md="4" class="d-flex flex-column align-center justify-start">
                                <v-card-text
                                    class="ma-0 pa-0 d-flex font-weight-bold text-h6 primary--text justify-center align-start">
                                    Opción de nivel
                                </v-card-text>
                                <v-card class="d-flex flex-column" v-model="selectedBtn" flat>
                                    <!-- Usar v-slide-group solo para pantallas pequeñas -->
                                    <v-slide-group v-if="$vuetify.breakpoint.xsOnly" center-active show-arrows mandatory
                                        v-model="selectedBtn">
                                        <v-slide-item v-for="button in buttons" :key="button.value"
                                            :value="button.value" class="align-center justify-center">
                                            <v-btn class="white--text font-weight-bold justify-center ml-1 px-3 py-5"
                                                :class="(button.reduce) ? 'px-6' : ''" style="border: 2px solid;"
                                                :outlined="selectedBtn !== (button.value >= 6 ? 6 : button.value)"
                                                :color="(button.reduce) ? `orange darken-2` : `primary`"
                                                @click="selectButton(button.value)">
                                                {{ button.text }}
                                            </v-btn>
                                        </v-slide-item>
                                    </v-slide-group>
                                    <!-- Botones organizados en columna cuando es mayor a 960px, sino en fila cuando es menor a 960px y no es xs-->
                                    <v-card-text v-else class="d-flex align-center justify-start"
                                        :class="$vuetify.breakpoint.mdAndUp ? 'flex-column' : 'flex-row'">
                                        <v-btn v-for="button in buttons" :key="button.value" :value="button.value"
                                            :width="$vuetify.breakpoint.mdAndUp ? '110' : '90'"
                                            :outlined="selectedBtn !== (button.value >= 6 ? 6 : button.value)"
                                            elevation="0" class="white--text font-weight-bold justify-center "
                                            style="border: 2px solid;"
                                            :color="(button.reduce) ? `orange darken-2` : `primary`"
                                            :class="($vuetify.breakpoint.mdAndUp) ? 'pa-5 mb-1' : 'ml-1 px-5 py-5'"
                                            @click="selectButton(button.value)">
                                            {{ button.text }}
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="8" class="d-flex justify-end align-start">
                                <v-card v-if="selectedBtn < 6" class="d-flex flex-column align-end" flat>
                                    <v-card-text class="font-weight-bold text-h5 primary--text">
                                        NIVEL
                                        {{ itemNivel[selectedBtn - 1].nivel }}
                                        <div v-if="selectedBtn == 1" class="d-flex flex-row subtitulo">
                                            {{ subtituloNivel }}
                                        </div>
                                        <div class="mt-4 font-weight-bold text-body-2" v-if="!beneficioDiscapacidad">
                                            <v-card color="secondary" dark
                                                class="d-inline align-center justify-center pa-3 rounded-0" flat>
                                                {{ itemNivel[selectedBtn - 1].cantMod }} MÓDULOS MENSUALES
                                            </v-card>
                                        </div>
                                        <div v-else class="mt-4 font-weight-bold text-body-2">
                                            <v-card color="secondary" dark
                                                class="d-inline align-center justify-center pa-3 rounded-0" flat>
                                                {{ itemNivel[selectedBtn - 1].cantMod }} MÓDULOS
                                            </v-card>
                                            <v-card color="orange" dark class="d-inline pl-8 py-3 pr-5 rounded-0" flat>
                                                75%
                                            </v-card>
                                            <v-card color="white" style="border: 4px solid #FF9900 !important;"
                                                class="d-inline align-center justify-center pa-2 px-7 rounded-0" flat>
                                                {{ itemNivel[selectedBtn - 1].cantMod * 0.75 }} MÓDULOS
                                            </v-card>
                                        </div>
                                    </v-card-text>
                                    <v-card-text class="text-body-1 black--text" auto-height>
                                        {{ buttons[selectedBtn - 1].parrafo }}
                                    </v-card-text>
                                    <div class="d-flex flex-row justify-end align-end">
                                        <v-btn text color="primary" @click="goToWeb()"
                                            class="d-flex flex-row justify-end pa-5 elevation-0"><v-icon
                                                class="mr-2">mdi-information-outline</v-icon>Más
                                            información en
                                            la web</v-btn>
                                    </div>
                                    <v-card-text class="d-flex flex-column align-center">
                                        <v-btn color="primary" :disabled="false"
                                            class="py-5 px-9 font-weight-bold elevation-0"
                                            @click="itemSeleccionado(buttons[selectedBtn - 1].value)">
                                            SELECCIONAR {{ buttons[selectedBtn - 1].text }}
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                                <v-card v-else flat>
                                    <v-card-text class="font-weight-regular text-h5 primary--text">
                                        {{ buttons[selectedBtn - 1].text_completo }}
                                        <div class="d-flex d-inline-flex font-weight-bold">
                                            ({{ buttons[selectedBtn - 1].text }})
                                        </div>
                                        <div v-if="reconsidera" class="d-flex flex-row subtitulo primary--text">
                                            A reconsiderar años anteriores
                                        </div>
                                    </v-card-text>
                                    <v-card-text class="text-body-1 black--text" auto-height>
                                        {{ buttons[selectedBtn - 1].parrafo }}
                                    </v-card-text>
                                    <v-card-text>
                                        <v-card v-for="(items, indice) in resumen[0]" :key="indice" flat class="mb-1">
                                            <div class="d-flex justify-center" v-if="items !== false">
                                                <v-chip label color="secondary"
                                                    class="espacio-letras font-weight-bold rounded-0 text-caption">
                                                    {{ indice }} MÓDULOS MENSUALES
                                                </v-chip>
                                                <v-chip label class="rounded-0 pa-3 font-weight-regular text-caption"
                                                    style="border:3px solid #092E6F; background-color: white;">
                                                    Años: {{ items }}
                                                </v-chip>
                                            </div>
                                        </v-card>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-end ma-0 pa-0">
                                        <v-btn text color="primary" @click="goToWeb()" class="pa-5"><v-icon
                                                class="mr-2">mdi-information-outline</v-icon>Más
                                            información en
                                            la web</v-btn>
                                    </v-card-text>
                                    <v-card-actions class="justify-center">
                                        <v-btn color="primary" :disabled="false"
                                            class="py-5 px-8 font-weight-bold elevation-0"
                                            @click="itemSeleccionado(buttons[selectedBtn - 1].value)">
                                            SELECCIONAR {{ buttons[selectedBtn - 1].text }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import DialogoConfirmar from '@/components/dialogos/DialogoConfirmar.vue'

export default {
    //'titulo', 'width', 'tipo'
    props: ['width']
    ,
    mounted() {

        if (this.isAuthenticated)
            this.selectedBtn = this.nivelAfiliado
    },
    components: {
        DialogoConfirmar,
    },
    data() {
        return {
            nivel: '',
            aceptar: 'Si, confirmar',
            cancelar: 'No, cancelar',
            mensaje: 'Estás seleccionando un nivel de aporte superior. ¿Querés continar?',
            isActive: false,
            e1: 0,
            titulo: 'Elegí un nivel de aporte',
            infoPrincipal: "La Caja contempla que seas vos quien elija libremente el Nivel de aportes que querés realizar, lo que determina, además del importe a abonar mensualmente, la futura jubilación y el monto a percibir en las prestaciones de esta caja. Siendo el Nivel 2 el nivel mínimo de aportación a la Caja.",
            subtituloNivel: 'Jubilación reducida y complementaria del haber principal de otro régimen previsional.',
            //values btn toggle
            selectedBtn: '1',
            initialValue: '',

            // agrego items para PMJ y/o RAR
            buttons: [
                {
                    value: 1,
                    text: 'NIVEL 1',
                    nivel: 1,
                    parrafo: "Este beneficio es optativo y puede ser solicitado por la/el Profesional Psicóloga/o que ejerciendo la psicología en relación de dependencia, en el ámbito de la Provincia de Buenos Aires, se encuentran obligados a realizar aportes a ANSES o IPS. Deberán presentar recibo de sueldo y certificado de trabajo.Esta opción debe renovarse anualmente, durante los meses de octubre y noviembre.",
                    route: 'https://www.cajapsipba.org.ar/valores-de-aportes-y-prestaciones.asp',
                },
                {
                    value: 2,
                    text: 'NIVEL 2',
                    nivel: 2,
                    route: 'https://www.cajapsipba.org.ar/valores-de-aportes-y-prestaciones.asp',
                    parrafo: "Este nivel corresponde a la jubilación mínima, no requiere renovación anual, permaneciendo en el nivel elegido hasta tanto gestione el cambio del mismo."
                },
                {
                    value: 3,
                    text: 'NIVEL 3',
                    nivel: 3,
                    parrafo: "Los niveles 3, 4 y 5 son para aquellos afiliadas/os que deciden aportar más para gozar de una mejor jubilación. Estos niveles, no requieren renovación anual, permaneciendo en el nivel elegido hasta tanto gestione el cambio del mismo.",
                    route: 'https://www.cajapsipba.org.ar/valores-de-aportes-y-prestaciones.asp',
                },
                {
                    value: 4,
                    text: 'NIVEL 4',
                    nivel: 4,
                    route: 'https://www.cajapsipba.org.ar/valores-de-aportes-y-prestaciones.asp',
                    parrafo: "Los niveles 3, 4 y 5 son para aquellos afiliadas/os que deciden aportar más para gozar de una mejor jubilación. Estos niveles, no requieren renovación anual, permaneciendo así en el nivel elegido hasta tanto gestione el cambio de nivel."
                },
                { value: 5, text: 'NIVEL 5', nivel: 5, route: 'https://www.cajapsipba.org.ar/valores-de-aportes-y-prestaciones.asp', parrafo: "Los niveles 3, 4 y 5 son para aquellos afiliadas/os que deciden aportar más para gozar de una mejor jubilación. Estos niveles, no requieren renovación anual, permaneciendo así en el nivel elegido hasta tanto gestione el cambio de nivel." },
            ],
        }
    },
    watch: {

    },
    methods: {
        inicializarButtons() {
            this.$nextTick(() => {
                this.initialValue = this.selectedBtn;
            })
            if (this.aporteReducido) {
                if (this.buttons.length == 5) this.buttons.push(this.itemReduce[0])
            } else {
                if (this.buttons.length == 6) this.buttons.pop()
            }
        },
        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result)
                this.callback = null
            }
            if (this.buttons.length !== 5) {
                this.selectedBtn = 1
                this.buttons.pop()
            }
            this.isActive = false
        },
        selectButton(value) {
            this.selectedBtn = ((value >= 6)) ? 6 : value;
            //   this.itemSeleccionado(value)
        },
        clickBtn(value) {
            this.botonSeleccionado = value;
        },

        abrirDialogo() {
            this.isActive = true;
            this.inicializarButtons();
            // Actualiza el initialValue cada vez que se abre el diálogo
            this.initialValue = this.selectedBtn;
            return new Promise(resolve => {
                this.callback = resolve;
            });
        },
        cerrarDialogo() {
            if (this.callback) {
                this.callback(result)
                this.callback = null
            }
            this.isActive = false
        },
        itemSeleccionado(value) {
            // Si el valor inicial es 6 (reducido) y el nuevo valor es distinto de 6 o 1, pide confirmación
            const cambiandoDesdeReducido = this.initialValue == 6 && (value !== 6 && value !== 1);
            if (cambiandoDesdeReducido && this.selectedBtn !== 6) {
                this.mensaje = 'Estás seleccionando un nivel de aporte superior. ¿Querés continar?'
                this.$refs.dialogoConfirmar.abrirDialogo().then((result) => {
                    if (result) {
                        // Usuario confirmó el cambio
                        this.confirmAndClose(true);
                        this.$emit('nivelSelected', value);
                    } else {
                        // Usuario canceló, vuelve al valor inicial
                        this.confirmAndClose(false);
                        this.$emit('nivelSelected', this.initialValue);
                    }
                });
            } else {
                // Cambio normal, sin confirmación
                this.confirmAndClose(true);
                this.$emit('nivelSelected', value);
            }
        },
        respuestaNivel(value) {
            this.titulo = value
            if (value.includes('REDUCIDA')) {
                this.e1 = 2
            } else {
                this.e1 = 1
            }
        },
        volver() {
            this.titulo = 'Elegí un nivel de aporte'
            this.e1 = 0
        },
        //valores de aportes y prestaciones
        goToWeb(url) {
            //const URL = 'https://www.cajapsipba.org.ar/valores-de-aportes-y-prestaciones.asp'
            window.open(url, '_blank');
        },
    },
    computed: {
        ...mapGetters('common', ['itemNivel']),
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('preafiliacion', ['aporteReducido', 'tipoAporteRed', 'resumen', 'reconsidera', 'itemReduce', 'datosPersonales']),
        ...mapGetters('opcionNivel', ['opcionNivelAfiliado']),

        nivelAfiliado() {
            return this.opcionNivelAfiliado.nivelActual
        },
        deshabiliarBtn() {
            return true
        },
        beneficioDiscapacidad() {
            return (this.datosPersonales.tramita_discapacidad == 'S') && !(this.aporteReducido)
        }
    }
}

</script>

<style>
.espacio-letras {
    letter-spacing: .05rem;
}

.subtitulo {
    /*     font-family: system-ui; */
    font: caption;
    font-size: 1.2rem;
    padding: 3px 0 6px 0;
}
</style>
